


















import Vue from 'vue';
import type { PropOptions } from 'vue';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import TestimonialIcon from './HeaderMenuNotificationsCardTestimonial/images/testimonial-icon.vue.svg';
import type { Notification } from '~/types/graphql';
import HeaderMenuNotificationsCardGridAvatar from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardConnectionsReminder',
  components: { HeaderMenuNotificationsCardGrid, HeaderMenuNotificationsCardGridAvatar, TestimonialIcon },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
});
